import { useSelector } from 'react-redux'
import ToDo from './ToDo'
const TodoListMain = () => {
   let todos= useSelector((state)=>{
    return state.storetwo.todos
   })
    console.log(todos);
  return (
    <ul className='list-group mt-4'>
        {
            todos.map((todo)=>{
                return(
                    <ToDo id={todo.id} title={todo.title} key={todo.title}/>
                )
            })
        }
    </ul>
  )
}

export default TodoListMain